var exports = {
  "kL": "container__sd6Vn1",
  "N1": "headerContainer__HsPEB-",
  "wx": "header__zkAJDz",
  "pW": "leadingVisual__34XNgI",
  "Qq": "text__RswDQz",
  "DD": "title__hdsHyh",
  "Ln": "shimmerContent__4aCZhU",
  "ai": "chevron__9sBU3K",
  "TI": "referenceContent__UZYrQJ",
  "ZD": "fallbackDetails__0dipU8",
  "MX": "detailsMessage__7lVFda",
  "MP": "detailsCode__SjVd7r",
};

module.exports = exports;
